import React from "react";

const AddressSelectBox2 = ({
  className,
  OptionValue,
  onChange,
  name,
  id,
  myRef,
  validationMsg,
  defaultValue,
}) => {
  const OptionData = OptionValue.map((addressData, index) => {
    return (
      <option value={addressData.id} key={index}>
        {addressData.address}
      </option>
    );
  });
  return (
    <>
      <select
        className={className}
        name={name}
        ref={myRef}
        onChange={onChange}
        id={id}
        defaultValue={defaultValue}
      >
        {/* {OptionData} */}
        
        {OptionData.length === 0 && <option>{defaultValue}</option>}
        {OptionData}
        
      </select>
      {validationMsg && (
        <>
          <span className="error_msg">{validationMsg}</span>
        </>
      )}
    </>
  );
};

export default AddressSelectBox2;
